<div class="toast-box">
  <div class="toast-message" [innerHTML]="toastMessage"></div>
</div>
